module.exports = __webpack_public_path__ + "static/fonts/ropasans-regular-webfont.1d602d0.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/ropasans-regular-webfont.eot
// module id = 117
// module chunks = 0